module.exports = __webpack_public_path__ + "static/media/VVA200229003.f2413d91.pdf";